import {
  ACCESS_TOKEN_STORAGE_KEY,
  refreshSession,
  setAccessToken,
} from 'infrastructure/actions/session'
import { CALL_API } from 'redux-api-middleware'

export const ACTIVATE_USER_REQUEST = 'ACTIVATE_USER_REQUEST'
export const ACTIVATE_USER_SUCCESS = 'ACTIVATE_USER_SUCCESS'
export const ACTIVATE_USER_FAILURE = 'ACTIVATE_USER_FAILURE'
export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST'
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS'
export const FORGOT_PASSWORD_FAILURE = 'FORGOT_PASSWORD_FAILURE'
export const REGISTER_REQUEST = 'REGISTER_REQUEST'
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS'
export const REGISTER_FAILURE = 'REGISTER_FAILURE'
export const REQUEST_LOGIN_REQUEST = 'REQUEST_LOGIN_REQUEST'
export const REQUEST_LOGIN_SUCCESS = 'REQUEST_LOGIN_SUCCESS'
export const REQUEST_LOGIN_FAILURE = 'REQUEST_LOGIN_FAILURE'
export const TEMPORARY_PASSWORD_REQUEST = 'TEMPORARY_PASSWORD_REQUEST'
export const TEMPORARY_PASSWORD_SUCCESS = 'TEMPORARY_PASSWORD_SUCCESS'
export const TEMPORARY_PASSWORD_FAILURE = 'TEMPORARY_PASSWORD_FAILURE'
export const REGISTER_RETAILER_REQUEST = 'REGISTER_RETAILER_REQUEST'
export const REGISTER_RETAILER_SUCCESS = 'REGISTER_RETAILER_SUCCESS'
export const REGISTER_RETAILER_FAILURE = 'REGISTER_RETAILER_FAILURE'

export const RECOVER_PASSWORD_REQUEST = 'RECOVER_PASSWORD_REQUEST'
export const RECOVER_PASSWORD_SUCCESS = 'RECOVER_PASSWORD_SUCCESS'
export const RECOVER_PASSWORD_FAILURE = 'RECOVER_PASSWORD_FAILURE'

export const requestLogin = (email, password) => {
  return dispatch => {
    return dispatch({
      [CALL_API]: {
        endpoint: '/login',
        types: [
          REQUEST_LOGIN_REQUEST,
          REQUEST_LOGIN_SUCCESS,
          REQUEST_LOGIN_FAILURE,
        ],
        method: 'POST',
        body: {
          email,
          password,
        },
      },
    }).then(response =>
      Promise.all([
        dispatch(
          setAccessToken(
            response.payload.accessToken,
            response.payload.accessTokenExpiration
          )
        ),
        dispatch(refreshSession()),
      ])
    )
  }
}

export const activateUser = code => {
  return dispatch => {
    return dispatch({
      [CALL_API]: {
        endpoint: `/activate/${code}`,
        method: 'POST',
        types: [
          ACTIVATE_USER_REQUEST,
          ACTIVATE_USER_SUCCESS,
          ACTIVATE_USER_FAILURE,
        ],
      },
    }).then(response => {
      if (response.error) {
        return response
      }

      return Promise.all([
        dispatch(
          setAccessToken(
            response.payload.accessToken,
            response.payload.accessTokenExpiration
          )
        ),
        dispatch(refreshSession()),
      ])
    })
  }
}

export const requestRegister = (email, source = null) => {
  let requestBody = { email }

  if (source) {
    requestBody['source'] = source
  }

  return {
    [CALL_API]: {
      endpoint: '/login/register',
      method: 'POST',
      body: requestBody,
      types: [
        REGISTER_REQUEST,
        {
          type: REGISTER_SUCCESS,
          meta: {
            email,
          },
        },
        REGISTER_FAILURE,
      ],
    },
  }
}

export const requestCompleteForgotPassword = (
  password,
  password_confirmation,
  code
) => {
  return {
    [CALL_API]: {
      endpoint: '/login/complete-forgot-password',
      method: 'POST',
      body: {
        code,
        password,
        password_confirmation,
      },
      types: [
        RECOVER_PASSWORD_REQUEST,
        RECOVER_PASSWORD_SUCCESS,
        RECOVER_PASSWORD_FAILURE,
      ],
    },
  }
}

export const requestForgotPassword = email => {
  return {
    [CALL_API]: {
      endpoint: '/login/forgot-password',
      method: 'POST',
      body: {
        email,
      },
      types: [
        FORGOT_PASSWORD_REQUEST,
        FORGOT_PASSWORD_SUCCESS,
        FORGOT_PASSWORD_FAILURE,
      ],
    },
  }
}

export const requestNewTemporaryPassword = email => {
  return {
    [CALL_API]: {
      endpoint: '/login/temporary-password',
      method: 'POST',
      body: {
        email,
      },
      types: [
        TEMPORARY_PASSWORD_REQUEST,
        TEMPORARY_PASSWORD_SUCCESS,
        TEMPORARY_PASSWORD_FAILURE,
      ],
    },
  }
}

export const registerRetailer = (companyName, contactPerson, emailAddress) => ({
  [CALL_API]: {
    endpoint: '/login/register-retailer',
    method: 'POST',
    body: {
      company_name: companyName,
      contact_person: contactPerson,
      email: emailAddress,
    },
    types: [
      REGISTER_RETAILER_REQUEST,
      REGISTER_RETAILER_SUCCESS,
      REGISTER_RETAILER_FAILURE,
    ],
  },
})
